// extracted by mini-css-extract-plugin
module.exports = {"FormTemplate":"styles_FormTemplate__4bKFC","submit":"styles_submit__pC_jX"};